export const MEMBERSHIP_TIER_DEFAULTS = {
  standard: {
    activationCreditPercent: 0.02,
    clickToFlyPercent: 0.015,
    referralBonusPercent: 0.01,
  },
  reload: {
    activationCreditPercent: 0.04,
    clickToFlyPercent: 0.03,
    referralBonusPercent: 0.02,
  },
};

export const DEPOSIT_TIER_LABELS = {
  mobility: "Mobility ($150k)",
  enhanced: "Enhanced ($300k)",
  enterprise: "Enterprise ($500k)",
};

export const BENEFITS_TIER_LABELS = {
  standard: "Standard",
  reload: "Reload",
};

export const MEMBERSHIP_PERCENT_STEP = 0.005;
export const MEMBERSHIP_PERCENT_MAX = 0.1;

export const DEPOSIT_TIER_OPTIONS = Object.keys(DEPOSIT_TIER_LABELS).map(
  (value) => ({ value, label: DEPOSIT_TIER_LABELS[value] })
);

export const BENEFITS_TIER_OPTIONS = Object.keys(BENEFITS_TIER_LABELS).map(
  (value) => ({ value, label: BENEFITS_TIER_LABELS[value] })
);

export const MEMBERSHIP_PERCENT_OPTIONS = Array.from({ length: 21 }, (_, i) => {
  const decimal = +(i * MEMBERSHIP_PERCENT_STEP).toFixed(4);
  return {
    value: decimal,
    label: `${(decimal * 100).toFixed(1)}%`,
  };
});

export const formatPercent = (value) => {
  if (value === null || value === undefined || Number.isNaN(value)) return "";
  return `${(value * 100).toFixed(1)}%`;
};

export const parsePercentInput = (raw) => {
  if (raw === null || raw === undefined) return null;
  const cleaned = String(raw).replace("%", "").trim();
  if (cleaned === "") return null;
  const asNumber = Number(cleaned);
  if (!Number.isFinite(asNumber)) return null;
  return asNumber / 100;
};

export const isValidMembershipPercent = (value) => {
  if (value === null || value === undefined) return true;
  if (typeof value !== "number" || !Number.isFinite(value)) return false;
  if (value < 0 || value > MEMBERSHIP_PERCENT_MAX) return false;
  const ratio = value / MEMBERSHIP_PERCENT_STEP;
  return Math.abs(ratio - Math.round(ratio)) < 1e-6;
};

export const emptyMembership = () => ({
  activationDate: null,
  depositTier: null,
  benefitsTier: null,
  activationCreditPercent: null,
  clickToFlyPercent: null,
  referralBonusPercent: null,
});
